function TextBlastIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M7.548 7.75H1.119C.502 7.75 0 8.236 0 8.834c0 .597.502 1.083 1.12 1.083h6.428c.618 0 1.119-.486 1.119-1.083 0-.598-.501-1.084-1.12-1.084zM7.581 18.583H5.419c-.599 0-1.086.487-1.086 1.084 0 .597.487 1.083 1.086 1.083h2.162c.6 0 1.086-.486 1.086-1.083 0-.598-.486-1.084-1.086-1.084zM7.59 13.167H3.243c-.593 0-1.076.486-1.076 1.083s.482 1.083 1.076 1.083H7.59a1.08 1.08 0 001.077-1.083 1.08 1.08 0 00-1.077-1.083zM24.137 7.75H11.614A1.864 1.864 0 009.75 9.617v8.923c0 1.031.834 1.867 1.863 1.867h3.213v2.846a.746.746 0 001.27.528l3.368-3.374h4.674A1.865 1.865 0 0026 18.54V9.617c0-1.031-.834-1.867-1.863-1.867z" />
    </svg>
  )
}

export default TextBlastIcon
